import { createSlice } from "@reduxjs/toolkit";

import { ModalType } from "../../../enum/health-monitor/ModalType";

interface Modal {
  modalType: ModalType | null;
  isShellModalVisible: boolean;
  isCommandLineInterfaceModalOpen: boolean;
}

const initialState: Modal = {
  modalType: null,
  isShellModalVisible: false,
  isCommandLineInterfaceModalOpen: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setModalType: (state, { payload }) => {
      state.modalType = payload;
    },
    setIsShellModalVisible: (state, { payload }) => {
      state.isShellModalVisible = payload;
    },
    setIsCommandLineInterfaceModalOpen: (state, { payload }) => {
      state.isCommandLineInterfaceModalOpen = payload;
    },
    closeModal: (state) => {
      state.modalType = null;
      state.isShellModalVisible = false;
    },
  },
});

export const {
  setModalType,
  setIsShellModalVisible,
  setIsCommandLineInterfaceModalOpen,
  closeModal,
} = modalSlice.actions;

export default modalSlice.reducer;
